'use client'

import { useCallback, useState } from 'react'
import { BlockStack, Box, Button, Popover, Text } from '@shopify/polaris'
import type { ReportingHelpSection } from '@/lib/reporting/reportingHelpCopy'

const ACTIVATOR_LABEL = 'How this works'

export function ReportingHowThisWorksPopover(props: {
  sections: ReportingHelpSection[]
  disabled?: boolean
}) {
  const { sections, disabled = false } = props
  const [active, setActive] = useState(false)

  const toggle = useCallback(() => {
    setActive((a) => !a)
  }, [])

  return (
    <Popover
      active={active}
      preferredAlignment="left"
      activator={
        <Button variant="plain" size="slim" disabled={disabled} onClick={toggle}>
          {ACTIVATOR_LABEL}
        </Button>
      }
      onClose={() => setActive(false)}
    >
      <Box padding="400" maxWidth="400px">
        <BlockStack gap="300">
          {sections.map((s, i) => (
            <BlockStack key={`${s.heading}-${i}`} gap="100">
              <Text as="h3" variant="headingSm">
                {s.heading}
              </Text>
              <Text as="p" variant="bodySm" tone="subdued">
                {s.body}
              </Text>
            </BlockStack>
          ))}
        </BlockStack>
      </Box>
    </Popover>
  )
}
